import { render, staticRenderFns } from "./CPFormCard.vue?vue&type=template&id=f77019a0"
import script from "./CPFormCard.vue?vue&type=script&lang=js"
export * from "./CPFormCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports